import { ClaimDetails } from '.';
import { Question, QuestionResponse } from 'wtw-ui-components';

export class ClaimDetailsRequest {
  public claimDetails: ClaimDetails;
  public sponsorId: number;
  public productId: number;
  public policyId: number;
  public languageId: number;
  public answeredQuestions: Question[];
  public claimQuestionResponse: QuestionResponse[];
  public finalQuestionAnswered: boolean;
  public allQuestionsAnswered: boolean;
  public emailId: string;
  public customerId: number;

  constructor(claimDetails: ClaimDetails, sponsorId: number, productId: number, policyId: number, languageId: number,
              claimQuestionResponse: QuestionResponse[] = null,
              finalQuestionAnswered: boolean = false, allQuestionsAnswered: boolean = false, customerId: number = 0, emailId?: string ) {
    this.claimDetails = claimDetails;
    this.sponsorId = sponsorId;
    this.productId = productId;
    this.policyId = policyId;
    this.languageId = languageId;
    this.claimQuestionResponse = claimQuestionResponse;
    this.finalQuestionAnswered = finalQuestionAnswered;
    this.allQuestionsAnswered = allQuestionsAnswered;
    this.emailId = emailId;
    this.customerId = customerId;
  }
}
